<template>
  <chip variant="danger" size="large">{{ $attrs.heading.type }}</chip>
</template>
<script>
export default {
  name: 'NullInput'
}
</script>
